/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export { AvatarIsOwnerOfERC721__factory } from "./AvatarIsOwnerOfERC721__factory";
export { IModifier__factory } from "./IModifier__factory";
